'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
var input$1 = require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
var usePrefersColorScheme = require('../../../../hooks/use-prefers-color-scheme.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
var input = require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('../../../internal/list/standard-list/standard-list.js');
require('../../../internal/listbox/standard-listbox/standard-listbox.js');
require('../../../internal/listitem/standard-listitem/standard-listitem.js');
require('../../../internal/option/standard-option/standard-option.js');
require('../../../internal/textarea/fake-textarea.js');
require('../../../internal/textfield/textfield-addon.js');
var textfieldBody = require('../../../internal/textfield/textfield-body.js');
var textfieldHeader = require('../../../internal/textfield/textfield-header.js');
require('../../../internal/textfield/textfield-icon.js');
require('../../../internal/textfield/textfield-inner.js');
var textfieldWrapper = require('../../../internal/textfield/textfield-wrapper.js');
var baseCodeEditor = require('../base-code-editor/base-code-editor.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseStandardCodeEditor = (props)=>{
    const { bodyProps , className , codeEditorProps , defaultValue , disabled , error , errorProps , headerProps , helpText , helpTextProps , id , label , labelPosition , labelProps , language , look , maxLength , minLength , name , onBlur , onChange , onEdit , onFocus , padding , placeholder , readOnly , required , requiredLabel , showLabel , textfieldProps , value , wrapperRef , ...otherProps } = props;
    const hasError = !!error;
    const hasHelpText = !!helpText;
    const hasRequired = required && !!requiredLabel;
    const helpTextId = `${id}-help-text`;
    const inlineAlertId = `${id}-inline-alert`;
    const colorScheme = usePrefersColorScheme.usePrefersColorScheme();
    const [focused, setFocused] = React.useState(false);
    React.useEffect(()=>{
        const html = document.querySelectorAll('html')[0];
        html.dataset.colorMode = colorScheme === 'dark' ? 'dark' : 'light';
    }, [
        colorScheme
    ]);
    return /*#__PURE__*/ React__default.default.createElement(textfieldWrapper.TextfieldWrapper, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-code-editor__standard': true,
            'bf-code-editor__standard--disabled': disabled,
            'bf-code-editor__standard--error': hasError,
            'bf-code-editor__standard--focused': focused,
            'bf-code-editor__standard--help-text': hasHelpText,
            'bf-code-editor__standard--label-hidden': !showLabel,
            [`bf-code-editor__standard--label-${labelPosition}`]: showLabel,
            [`bf-code-editor__standard--look-${look}`]: look,
            'bf-code-editor__standard--placeholder': !!placeholder,
            'bf-code-editor__standard--readonly': readOnly,
            'bf-code-editor__standard--required': hasRequired,
            [`${className}`]: !!className
        }),
        labelPosition: labelPosition,
        ref: wrapperRef
    }), /*#__PURE__*/ React__default.default.createElement(textfieldHeader.TextfieldHeader, _extends({}, headerProps, {
        className: classnames__default.default({
            'bf-code-editor__header': true,
            [`${headerProps?.className}`]: !!headerProps?.className
        }),
        error: error,
        errorProps: errorProps,
        htmlFor: id,
        inlineAlertId: inlineAlertId,
        label: label,
        labelPosition: labelPosition,
        labelProps: labelProps,
        required: required,
        requiredLabel: requiredLabel,
        showLabel: showLabel
    })), /*#__PURE__*/ React__default.default.createElement(textfieldBody.TextfieldBody, _extends({}, bodyProps, {
        className: classnames__default.default({
            'bf-code-editor__body': true,
            [`${bodyProps?.className}`]: !!bodyProps?.className
        }),
        error: error,
        errorProps: errorProps,
        helpText: helpText,
        helpTextId: helpTextId,
        helpTextProps: helpTextProps,
        inlineAlertId: inlineAlertId,
        labelPosition: labelPosition
    }), /*#__PURE__*/ React__default.default.createElement("div", _extends({}, textfieldProps, {
        className: classnames__default.default({
            'bf-code-editor__textfield': true,
            [`${textfieldProps?.className}`]: !!textfieldProps?.className
        })
    }), /*#__PURE__*/ React__default.default.createElement(baseCodeEditor.BaseCodeEditor, _extends({}, codeEditorProps, {
        "aria-describedby": hasError ? inlineAlertId : hasHelpText ? helpTextId : undefined,
        "aria-disabled": disabled,
        "aria-invalid": hasError,
        className: classnames__default.default({
            'bf-code-editor__editor': true,
            [`${codeEditorProps?.className}`]: !!codeEditorProps?.className
        }),
        defaultValue: defaultValue,
        disabled: disabled,
        id: id,
        language: language,
        maxLength: maxLength,
        minLength: minLength,
        name: name,
        onBlur: (e)=>{
            setFocused(false);
            if (onBlur) onBlur(e);
        },
        onChange: onChange,
        onEdit: onEdit,
        onFocus: (e)=>{
            setFocused(true);
            if (onFocus) onFocus(e);
        },
        padding: padding,
        placeholder: placeholder,
        readOnly: readOnly,
        required: required,
        value: value || ''
    })))));
};
const CodeEditor = styled__default.default(BaseStandardCodeEditor)`
  .bf-code-editor__textfield {
    ${input.baseInputStyle}
    ${input.getInputBorderRadius({})}
    ${({ error , look  })=>input.getInputTheme({
        codeEditor: true,
        error,
        look
    })}
    font-family: ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', Menlo,
      monospace;
    font-size: 14px;
    line-height: 20px;
    max-height: 100vh;
    min-height: 50px;
    overflow-y: auto;
    width: 100%;
  }

  &.bf-code-editor__standard--focused {
    .bf-code-editor__textfield {
      ${({ disabled , error , look  })=>input.getInputFocusedBorderColor({
        disabled,
        error,
        look
    })}
    }
  }

  .bf-code-editor__editor {
    width: 100%;
  }

  .npm__react-simple-code-editor__textarea {
    outline: 0;

    &:disabled {
      cursor: not-allowed;
    }
  }
`;
/**
 * A code editor component that features syntax highlighting and automatic newline indenting.

 * Code will automatically be sanitized via DOMPurify to remove any
 * [XSS attack](https://owasp.org/www-community/attacks/xss/) related code.
 * 
 * Required props include `id` and `label`. Use `onEdit` to access the code from the editor.
 * Note that the code will only be sanitized when the `<textarea>` is blurred.
 * If you need the unsanitized value, use `onChange` and bring your own sanitization code.
 *
 * You must install peer dependencies [DOMPurify](https://github.com/cure53/DOMPurify),
 * [react-simple-code-editor](https://github.com/react-simple-code-editor/react-simple-code-editor),
 * and [prismjs](https://github.com/PrismJS/prism).
 * in order to use this component.
 *
 * @param props StandardCodeEditorProps
 * @returns FunctionComponent<StandardCodeEditorProps>
 */ const StandardCodeEditor = (props)=>{
    const { labelPosition =input$1.InputLabelPositions.Top , look =input$1.InputLooks.Default , showLabel =true , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(CodeEditor, _extends({}, otherProps, {
        labelPosition: labelPosition,
        look: look,
        showLabel: showLabel
    })));
};

exports.StandardCodeEditor = StandardCodeEditor;
//# sourceMappingURL=standard-code-editor.js.map
